import ResetPassword from '@/components/Auth/ResetPassword'

const ResetPasswordScreen = () => {
  return <ResetPassword />
}

export default ResetPasswordScreen
